function join()
{
  var a = document.getElementsByName('Monogram_Input_1')[1].value;
  var b = document.getElementsByName('Monogram_Input_2')[1].value;
  var c = document.getElementsByName('Monogram_Input_3')[1].value;

  var combinedField = document.getElementsByClassName('pplr_text pplr_monogram p_u_t pplraddprice toUpperCase  ')[0];
  combinedField.value = a+b+c;

  // ✅ trigger input event so personalization preview reacts:
  var event = new Event('input', { bubbles: true });
  combinedField.dispatchEvent(event);

  document.getElementsByName('Monogram_Input_1')[1].addEventListener('input', function() {
    LoadPplrWithFont('1', true, this);
  }, false);
  document.getElementsByName('Monogram_Input_2')[1].addEventListener('input', function() {
    LoadPplrWithFont('1', true, this);
  }, false);
  document.getElementsByName('Monogram_Input_3')[1].addEventListener('input', function() {
    LoadPplrWithFont('1', true, this);
  }, false);

  var container = document.getElementsByClassName("injection_container")[0];
  container.onkeyup = function(e) {
    var target = e.srcElement;
    if (target.value.length >= target.maxLength) {
      var next = target;
      while (next = next.nextElementSibling) {
        if (next == null)
          break;
        if (next.tagName.toLowerCase() == "input") {
          next.focus();
          next.setSelectionRange(0, next.value.length);
          break;
        }
      }
    }
  };
  container.onkeypress = function(e) {
    let charCodeLimit = e.target.getAttribute("charCodeLimit");
    if (charCodeLimit) {
      let limit = JSON.parse(charCodeLimit);
      if(limit.length==2){
        return (e.charCode >= limit[0] && e.charCode <= limit[1]) || e.charCode == 0;
      }
    }
  };
  container.onclick = function(e) {
    if (e.target.tagName.toLowerCase() == "input") {
      e.target.select();
    }
  };
  //window.scrollTo(0, 0); - disabled as disturbing on mobile
}
